import * as swcHelpers from '@swc/helpers';
import { isBannerRecommendation } from './guards.js';

const mergeAndSortRecommendations = (recommendedProducts, recommendedBanners, options)=>{
    const positionAscending = (a, b)=>a.position - b.position
    ;
    const recommendations = recommendedProducts.map((p)=>swcHelpers.objectSpread({}, p, {
            recommendationType: 'product'
        })
    );
    const banners = recommendedBanners.map((b)=>swcHelpers.objectSpread({}, b, {
            recommendationType: 'banner'
        })
    );
    /*
   * Each promotion (a.k.a. banner) delivered by the backend has a position associated
   * with it. Here we make sure the promotions are interleaved with the
   * products, based on each promotion's "position" property.
   */ banners.sort(positionAscending).forEach((b)=>{
        if (isBannerRecommendation(b)) recommendations.splice(b.position, 0, b);
    });
    return (options === null || options === void 0 ? void 0 : options.maxItems) ? recommendations.slice(0, options.maxItems) : recommendations;
};

export { mergeAndSortRecommendations };
//# sourceMappingURL=merge-and-sort-recommendations.js.map
